import { ReactComponent as Plane } from '../../assets/svg/plane.svg';

export default Plane;
